import { Card, CardContent, CardHeader, Dialog, DialogActions, DialogContent, DialogTitle, Link } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import { Instance } from 'mobx-state-tree';
import * as React from 'react';
import { LogoIcon } from '../LogoIcon';
import { OcEdit } from '../main/OcEdit';
import { transl } from '../main/transl';
import { adaptDataviewStoreColumn } from '../stores/DataviewStoreColumn';
import { RegistrationDialogStore } from './RegistrationDialogStore';

const styles = createStyles({
	rootDialog: {
		'& .MuiTypography-root': {
			fontFamily: 'inherit',
			letterSpacing: 'inherit'
		}
	},
	MuiCardHeader_title: {
	},
	MuiCardHeader_subheader: {
	},
	card: {
	},
	cardHeader: {
	},
	cardContent: {
	},
	root: {
		'& .MuiBackdrop-root': {
			backgroundColor: 'rgba(0, 0, 0, 0)'
		}
	},
	content: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'stretch',
		width: '100%',
	},
	textField: {
	},
	button: {
	},
	linkPassword: {
	},
	linkNewAccout_login: {
	},
	logoContainer: {
	},
	logo: {
	},
	rtextField: {
		width: '100%',
	},
});

interface IRegistrationDialogProps {
	store: Instance<typeof RegistrationDialogStore>
	classes: any
}

function _RegistrationDialogMain({ store, classes }: IRegistrationDialogProps) {
	if (store.state !== 'MAIN') return null;
	return <Dialog open={true} className={classes.root} onClose={store.cancel} fullScreen>

		<div className={classes.rootDialog} >
			<div className={classes.logoContainer}><LogoIcon className={classes.logo} /></div>
			<Card className={classes.card}>
				<CardHeader className={classes.cardHeader} title={transl('titleRegistration')} subheader={transl('subHeadingRegistration')}
					classes={{ title: classes.MuiCardHeader_title, subheader: classes.MuiCardHeader_subheader }}
				/>
				<CardContent className={classes.cardContent}>
					{
						store.columns.map(c => <OcEdit
							column={adaptDataviewStoreColumn(c)}
							entity={store.user}
							errorText={store.errorText(c)}
							key={c.name}
							classes={{ root: classes.textField }}
							variant={'filled'}
							placeholder={true}
						/>)
					}
					<Button variant="contained" color="primary" className={classes.button} onClick={store.accept} disabled={!store.isValid} >
						{transl('startRegistration')}
					</Button>
					<div>
						<Link className={classes.linkNewAccout_login} onClick={store.cancel} >{transl('loginLinkText')}</Link>
					</div>
				</CardContent>

			</Card>

		</div>

	</Dialog >;
}

function _RegistrationDialogDone({ store, classes }: IRegistrationDialogProps) {
	return <Dialog open={true} onClose={store.cancel} className={classes.rootDialog} fullWidth>
		<DialogTitle>{transl('titleRegistrationDone')}</DialogTitle>
		<DialogContent className={classes.content}>{transl('registrationDoneContent')}</DialogContent>
		<DialogActions>
			<Button onClick={store.cancel} color="primary">{transl('ok')}</Button>
		</DialogActions>
	</Dialog>;
}

function _PasswordResetDialog({ store, classes }: IRegistrationDialogProps) {
	return <Dialog open={true} onClose={store.cancel} className={classes.rootDialog} fullWidth>
		<DialogTitle>{transl('confirmRecoverPasswordHeading')}</DialogTitle>
		<DialogContent className={classes.content}>{transl('confirmRecoverPassword', store.user.email)}</DialogContent>
		<DialogActions>
			<Button onClick={store.cancel} color="primary">{transl('cancel')}</Button>
			<Button onClick={store.resetAction} color="primary">{transl('ok')}</Button>
		</DialogActions>
	</Dialog>;
}

function _RegistrationDialog(props: IRegistrationDialogProps): JSX.Element | null {
	switch (props.store.state) {
	case 'NONE': return null;
	case 'MAIN': return _RegistrationDialogMain(props);
	case 'RESET': return _PasswordResetDialog(props);
	case 'DONE': return _RegistrationDialogDone(props);
	}
}

export const RegistrationDialog = withStyles(styles, { name: 'RegistrationDialog' })(observer(_RegistrationDialog));
